module.exports = __webpack_public_path__ + "img/fosun-logo-text@3x.b4aba078.png";